import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
  },
}))(LinearProgress);

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },

});

export default function CustomizedProgressBars(prop) {
  const classes = useStyles();
  const TheIcon = prop.icon;
  const [selectedItem, setSelectedItem] = React.useState('')



  return (
    <div className={classes.root}>
        <h5><img src={prop.image}/> {prop.name} </h5> 
        <BorderLinearProgress variant="determinate" value={prop.points*10}    />
    </div>
  );
}
